import $api, {API_URL} from "./instance";
import errorMessage from "../const/Tost";

export const DoctorService = {
    async getDirection(id){
        try{
            return await $api.get(`${API_URL}/direction/manage/${id}?withAssociates=true`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async updateDocForm(id, data){
        try{
            return await $api.put(`${API_URL}/direction/manage/${id}/doctor-form`, {...data, doctorId: data.doc})
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async updateStatusDirection(id, data){
        try{
            return await $api.put(`${API_URL}/direction/manage/${id}`, data)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getAllWorkersByRole(){
        try{
            return await $api.get(`${API_URL}/user/by-role`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async enter(){
        try{
            return await $api.post(`${API_URL}/register`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getDoctorPdf(id){
        try{
            return await $api.get(`${API_URL}/direction/manage/${id}/generate/result-html`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async sendSignedPdf(directionId, file){
        const formData = new FormData();
        formData.append('file', file);

        try{
            return await $api.post(
                `${API_URL}/direction/manage/${directionId}/signed-file`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getSignedPdf(id){
        try{
            return await $api.get(`${API_URL}/direction/manage/${id}/signed-file`, {responseType: 'arraybuffer'})
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async updateFinishedDocForm(id, data){
        try{
            return await $api.put(`${API_URL}/direction/manage/${id}/doctor-form/finished`, {...data})
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }
}